
    <ul class="layout-menu">
        <ng-container *ngFor="let item of menuItems(); let i = index">
            <li app-menu-item *ngIf="!item.separator" [item]="item" [index]="i" [menuId]="'main'"  [root]="true" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul>

    <ul class="layout-menu" style="margin-top: 2.5rem;">
        <ng-container *ngFor="let item of userMenuItems(); let i = index">
            <li app-menu-item *ngIf="!item.separator" [item]="item" [index]="i" [menuId]="'user'" [root]="true" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul>